export const ghostUrl = "https://www.ceo.com"
export default ghostUrl;